import { backgroundOrange, blackOrange, darkOrange, orange, warmTint } from '@/theme/colors'
import { radii, motion, layers } from '@/theme/tokens'
import styled from 'styled-components'
import { fontSizes } from '@/theme/typography'

export const TravelSegmentContainer = styled.div<{ $isHidden: boolean }>`
	display: ${props => (props.$isHidden ? 'none' : 'flex')};
	align-items: stretch;
`

/** Chip centre below the segment row's top: the 8px pad + half the 24px chip. */
export const TRAVEL_CHIP_ANCHOR = 20

/** Hosts the absolutely-positioned `RailConnector` down to the next event's dot. */
export const TravelDotColumn = styled.div`
	width: 24px;
	flex-shrink: 0;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0;
`

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	background: ${warmTint};
	border-radius: 50%;
	flex-shrink: 0;
	position: relative;
	z-index: ${layers.raised};

	svg {
		width: 14px;
		height: 14px;
		fill: ${darkOrange};
	}
`

export const SegmentContent = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	gap: 8px;
	margin-left: 10px;
	padding: 4px 8px 4px 12px;
	cursor: pointer;
	border-radius: ${radii.small};
	transition: background ${motion.fast};

	&:hover {
		background: ${backgroundOrange};
	}
`

export const InfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: ${fontSizes.micro};
	font-weight: 500;
	color: ${blackOrange};
`

export const Bullet = styled.span`
	color: ${darkOrange};
	font-weight: 700;
`

export const DirectionsText = styled.span`
	color: ${orange};
	font-weight: 700;
	font-size: ${fontSizes.micro};
	white-space: nowrap;
	margin-left: 2px;
`
